import { ModulesActionsFactory } from "../../Common/_stores/ModulesStore/ModulesActionsFactory";
import { BudgetsModules } from "../BudgetsModules";

const modulesActions = ModulesActionsFactory({
    defaultAppModule: BudgetsModules.DEFAULT_MODULE,
});

export const BudgetsModulesActions = {
    //PUBLIC
    selectModuleId: modulesActions.selectModule,
    setUpModules,

    _setUpModulesGeneric: modulesActions.setUpModules,
};

function setUpModules(hasDistributor = false, url, isReadOnly = false) {
    const enabledModuleIds = BudgetsModules.getEnabledModuleIds(hasDistributor, isReadOnly);

    return BudgetsModulesActions._setUpModulesGeneric(
        enabledModuleIds,
        getInitialModuleId(),
    );

    function getInitialModuleId() {
        if (!hasDistributor)
            return BudgetsModules.IDS.DISTRIBUTOR;

        const moduleId = BudgetsModules.getModuleIdForUrl(url);
        if (!isReadOnly)
            return moduleId;

        // The app default (licenses) is not enabled for a read-only employee
        return enabledModuleIds.includes(moduleId)
            ? moduleId
            : BudgetsModules.IDS.DEVICE_SEARCH
        ;
    }
}